import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { TranslatorContext } from "../context/Translator";
import { SidebarContext } from "../context/Sidebar";
import sidenavs from "../assets/data/sidenavs.json";

export default function SidebarLayout() {

    const { t, n, currentLanguage } = useContext(TranslatorContext);
    const { sidebar } = useContext(SidebarContext);
    const location = useLocation();

    const [counters, setCounters] = useState({ low_stock_count: 0, pending_sell_pets_count: 0 });

    const userPermissions = JSON.parse(localStorage.getItem("permissions") || "[]");

    useEffect(() => {
        const token = localStorage.getItem("authToken");

        if (!token) return;

        axios
            .get(`${process.env.REACT_APP_API_URL}/stock/low-stock/count`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                if (res.data?.status) {
                    setCounters((prev) => ({
                        ...prev,
                        low_stock_count: res.data.low_stock_count || 0,
                    }));
                }
            })
            .catch((err) => console.error("Error fetching sidebar counters:", err));

        axios
            .get(`${process.env.REACT_APP_API_URL}/sell-pets/pending-count`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                if (res.data?.status) {
                    setCounters((prev) => ({
                        ...prev,
                        pending_sell_pets_count: res.data.pending_sell_pets_count || 0,
                    }));
                }
            })
            .catch((err) => console.error("Error fetching sidebar counters:", err));
    }, [location.pathname]);

    const badgeCount = (menu) => {
        if (menu.badge?.source) return counters[menu.badge.source] || 0;
        return menu.badge?.count ?? null;
    };

    const handleDropdown = (event) => {
        const buttonElement = event.currentTarget;
        const itemElement = buttonElement.parentElement;
        const isActive = itemElement.classList.contains('active');
        const allItems = document.querySelectorAll('.mc-sidebar-menu-item');
        const allDropdowns = document.querySelectorAll('.mc-sidebar-dropdown-list');
        const dropdownElement = itemElement.querySelector('.mc-sidebar-dropdown-list');

        if (isActive) {
            itemElement.classList.remove('active');
            dropdownElement.style.height = "0px";
        }
        else {
            allItems.forEach(item => item.classList.remove('active'));
            allDropdowns.forEach(dropdown => dropdown.style.height = "0px");

            itemElement.classList.add('active');
            dropdownElement.style.height = dropdownElement.scrollHeight + "px";
        }
    }

    const hasPermission = (permission) => {
        if (!permission) return true;
        return userPermissions.includes(permission);
    };


    const filteredSidenavs = sidenavs.map((section) => ({
        ...section,
        menus: section.menus
            .filter((menu) => {
                if (!menu.permission) return true;

                // parent permission check
                const parentAllowed = hasPermission(menu.permission);

                // if submenu exists, check at least one submenu allowed
                if (menu.submenus) {
                    const hasSubmenuAccess = menu.submenus.some((sub) =>
                        hasPermission(sub.permission)
                    );

                    return parentAllowed || hasSubmenuAccess;
                }

                return parentAllowed;
            })
            .map((menu) => {
                if (!menu.submenus) return menu;

                return {
                    ...menu,
                    submenus: menu.submenus.filter((sub) =>
                        hasPermission(sub.permission)
                    ),
                };
            }),
    }));

    return (
        <aside as="aside" className={`mc-sidebar thin-scrolling ${sidebar && "active"}`}>
            {filteredSidenavs?.map((sidenav, sidenavIndex) => (
                <menu key={sidenavIndex} className="mc-sidebar-menu">
                    <h5 className="mc-sidebar-menu-title">{t(sidenav.title)}</h5>
                    <ul className="mc-sidebar-menu-list">
                        {sidenav.menus.map((menu, menuIndex) => (
                            <li key={menuIndex} className='mc-sidebar-menu-item'>
                                {menu.submenus ?
                                    <>
                                        <button type="button" className="mc-sidebar-menu-btn" onClick={handleDropdown}>
                                            <i className="material-icons">{menu.icon}</i>
                                            <span>{t(menu.text)}</span>
                                            {menu.badge?.text && <sup className={menu.badge.variant}>{t(menu.badge.text)}</sup>}
                                            {badgeCount(menu) > 0 && <sup className={menu.badge.variant}>{n(badgeCount(menu))}</sup>}
                                            {currentLanguage?.dir === "ltr" ?
                                                <small className="material-icons right">chevron_right</small>
                                                : <small className="material-icons left">chevron_left</small>
                                            }
                                        </button>

                                        <ul className='mc-sidebar-dropdown-list'>
                                            {menu.submenus.map((submenu, submenusIndex) => (
                                                <li key={submenusIndex} className="mc-sidebar-dropdown-item">
                                                    <Link to={submenu.path} className="mc-sidebar-dropdown-link">{t(submenu.text)}</Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                    :
                                    <Link to={menu.path} className="mc-sidebar-menu-btn">
                                        <i className="material-icons">{menu.icon}</i>
                                        <span>{t(menu.text)}</span>
                                        {badgeCount(menu) > 0 && <sup className={menu.badge.variant}>{n(badgeCount(menu))}</sup>}
                                        {menu.badge?.text && <sup className={menu.badge.variant}>{t(menu.badge.text)}</sup>}
                                    </Link>
                                }
                            </li>
                        ))}
                    </ul>
                </menu>
            ))}

            <div className="mc-sidebar-logout text-center">
                <Link to='/login' className="mc-btn primary sm">
                    <i className="material-icons">lock</i>
                    <span>{t('logout')}</span>
                </Link>
            </div>
        </aside>
    )
}